"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseString = void 0;
const withMessage_1 = require("../utils/withMessage");
const parseString = (schema) => {
  let r = "z.string()";
  r += (0, withMessage_1.withMessage)(schema, "format", ({ value }) => {
    switch (value) {
      case "email":
        return [".email(", ")"];
      case "ip":
        return [".ip(", ")"];
      case "ipv4":
        return ['.ip({ version: "v4"', ", message: ", " })"];
      case "ipv6":
        return ['.ip({ version: "v6"', ", message: ", " })"];
      case "uri":
        return [".url(", ")"];
      case "uuid":
        return [".uuid(", ")"];
      case "date-time":
        return [".datetime(", ")"];
    }
  });
  r += (0, withMessage_1.withMessage)(schema, "pattern", ({ json }) => [
    `.regex(new RegExp(${json})`,
    ", ",
    ")",
  ]);
  r += (0, withMessage_1.withMessage)(schema, "minLength", ({ json }) => [
    `.min(${json}`,
    ", ",
    ")",
  ]);
  r += (0, withMessage_1.withMessage)(schema, "maxLength", ({ json }) => [
    `.max(${json}`,
    ", ",
    ")",
  ]);
  return r;
};
exports.parseString = parseString;
